import getExperienceItems from 'checkout/selectors/view/items/getExperienceItems'
import { isBookingProtectionItem, isExperienceItem, isInsuranceItem, isLuxPlusSubscriptionItem } from 'lib/checkout/checkoutUtils'
import { createSelector } from 'reselect'

/**
 * Leaf selector: standalone experience cart detection.
 * Kept out of checkoutSelectors so experience view selectors can use it without
 * pulling luxPlusSubscription via checkoutSelectors.
 */
export const isStandaloneExperience = createSelector(
  (state: App.State) => state.checkout.cart.items,
  (state: App.State) => getExperienceItems(state),
  (allItems, experienceItems): boolean => {
    // a standalone experience can still have insurance/booking protection and/or a luxplus subscription
    return experienceItems.length > 0 && allItems.every(item =>
      isExperienceItem(item) ||
      isInsuranceItem(item) ||
      isBookingProtectionItem(item) ||
      isLuxPlusSubscriptionItem(item))
  },
)
